import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { MediaFile } from '../types';

@customElement('card-view')
export class GalleryCardView extends LitElement {
  static readonly styles = css`
    :host {
      font-family: Roboto, sans-serif;

      --background-color: #fff;
      --spacing-vertical: 12px;
      --spacing-horizontal: 24px;

      --xl-cols: 2;
      --lg-cols: 3;
      --md-cols: 4;
      --sm-cols: 6;
    }

    .card-view__root {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      gap: var(--spacing-horizontal);
    }

    .card-view__item {
      grid-column: span var(--md-cols);
    }

    /* Container queries for supporting browsers */
    @supports (container-type: inline-size) {
      .card-view {
        container-type: inline-size;
        container-name: gallery;
      }

      /* Reset media queries for container query support */
      .card-view__item {
        grid-column: span var(--md-cols);
      }

      @container gallery (max-width: 768px) {
        .card-view__item {
          grid-column: span var(--sm-cols);
        }
      }

      @container gallery (min-width: 768px) and (max-width: 1280px) {
        .card-view__item {
          grid-column: span var(--md-cols);
        }
      }

      @container gallery (min-width: 1280px) and (max-width: 1920px) {
        .card-view__item {
          grid-column: span var(--lg-cols);
        }
      }

      @container gallery (min-width: 1920px) {
        .card-view__item {
          grid-column: span var(--xl-cols);
        }
      }
    }
  `;

  @property({ type: Array })
  files: MediaFile[] = [];

  private readonly selectFile = (file: MediaFile) => {
    this.dispatchEvent(
      new CustomEvent('file-selected', {
        detail: {
          file,
        },
      })
    );
  };

  private readonly unselectFile = (file: MediaFile) => {
    this.dispatchEvent(
      new CustomEvent('file-unselected', {
        detail: {
          file,
        },
      })
    );
  };

  getImageUrl(file: MediaFile) {
    if (Object(window).hasOwnProperty('fzGetAssetsFileUrl')) {
      // @ts-ignore
      return window.fzGetAssetsFileUrl({
        url: file.url,
      });
    }

    return file.url;
  }

  render() {
    return html`
      <div class="card-view">
        <div class="card-view__root">
          ${this.files.map(
            file => html`
              <media-file-card
                class="card-view__item"
                .fileName=${file.name}
                .fileSize=${file.size}
                .fileType=${file.mime}
                .url=${file.url}
                .previewUrl=${this.getImageUrl(file)}
                .width=${file.width}
                .height=${file.height}
                .selectable=${true}
                .editable=${true}
                .removable=${true}
                @selected="${this.selectFile.bind(this, file)}"
                @unselected="${this.unselectFile.bind(this, file)}"
              ></media-file-card>
            `
          )}
        </div>
      </div>
    `;
  }
}

// <media-file-card
// class="cards__item"
// .canSelect="${this.canSelect() || this.isFileSelected(file)}"
// .file="${file}"
// @selected="${this.selectFile.bind(this, file)}"
// @unselected="${this.unselectFile.bind(this, file)}"
// ></media-file-card>
